

const multiSearchConfig = {
    apiOrder: ["store", "localities"],
    debounceTime: 100,
    localities: {
        key: 'woos-c1822d2f-e8ad-3603-859d-70d7afa385b4',
        fallbackBreakpoint: 0.4,
        params: {
        components: {
            country: ["fr"],
        },
        language: "en",
        data: 'advanced',
        types: ['locality', 'postal_code', 'address', 'admin_level', 'airport', 'train_station', 'metro_station', 'shopping', 'country'],
        },
    },
    store: {
        key: 'woos-c1822d2f-e8ad-3603-859d-70d7afa385b4',
        fallbackBreakpoint: false,
    },
};
export default {
    multiSearchConfig: multiSearchConfig
}
